import { Layout, Menu, Icon } from 'antd'

const { Header, Content, Sider } = Layout

import React from 'react'
import qs from 'query-string'
import { Route, HashRouter, Switch, Link } from 'react-router-dom'
import { stories } from './Login/Login.storybook'
import UserForm from './UserForm/UserForm'
import PatientMenu from './PatientMenu/PatientMenu'
import DoseForm from './DoseForm/DoseForm'
import DoseList from './DoseList/DoseList'
import CaregiverList from './CaregiverList/CaregiverList'
import PatientList from './PatientList/PatientList'
import MedicationList from './MedicationList/MedicationList'
import Report from './Report/Report'
import { withState, compose } from 'recompose'
import withScreen from 'react-sizes'
import _ from 'lodash'

const Home = () => <div>Home</div>

const enhance = compose(
  withState('collapsed', 'setCollapsed', true),
  withScreen(({ width }) => ({ isMobile: width < 900 }))
)

const subRoutes = {
  '/doses/add': DoseForm,
  '/doses/:doseId': DoseForm,
  '/doses': DoseList,
  '/medications': MedicationList,
  '/report': Report,
}

const WorkSpace = () => (
  <Content style={{ marginTop: '64px' }}>
    <Switch>
      <Route exact path="/home" component={Home} />
      {
        _.flattenDeep(
          _.map(['', '/patients/:patientId'], (prefix) => (
            _.map(subRoutes, (Component, path) => (
              <Route path={`${prefix}${path}`} component={Component} />
            ))
          ))
        )
      }
      <Route path="/me" component={UserForm} />
      <Route path="/caregivers" component={CaregiverList} />
      <Route path="/patients/:patientId/menu" component={PatientMenu} />
      <Route path="/patients" component={PatientList} />
    </Switch>
  </Content>
)

const MenuList = (props) => {
  const token = qs.parse(location.hash.split('?').pop()).token || localStorage.getItem('token')
  return (
    <Menu {...props}>
      {
        _.map(menus, ({ type, text, to }, i) => (
          <Menu.Item key={i + 1}>
            <Link to={`${to}${token ? `?token=${token}` : ''}`}>
              <Icon type={type} />
              <span className="nav-text">{text}</span>
            </Link>
          </Menu.Item>
        ))
      }
    </Menu>
  )
}

const menus = [
  { type: 'appstore-o', text: 'จัดการยา', to: '/doses' },
  { type: 'pie-chart', text: 'สรุปผล', to: '/report' },
  { type: 'book', text: 'ประวัติการทานยา', to: '/medications' },
  { type: 'smile-o', text: 'ผู้ดูแล', to: '/caregivers' },
  { type: 'team', text: 'ผู้ป่วยในการดูแล', to: '/patients' },
  { type: 'user', text: 'ข้อมูลส่วนตัว', to: '/me' }
]

const Logo = (props) => (
  <div
    className="logo"
    style={_.merge({
      width: '120px',
      height: '31px',
      lineHeight: '31px',
      color: 'white',
      textAlign: 'center',
      background: '#333',
      'border-radius': '6px',
      margin: '16px 24px 16px 0',
      float: 'left'
    }, props.style)}
  >
    Remeind
  </div>
)

const App = ({ setCollapsed, collapsed, isMobile }) => (
  <Layout>
    {
      isMobile && (
        <Sider
          trigger={null}
          collapsible
          collapsed={collapsed}
          collapsedWidth={0}
        >
          <Logo style={{ float: 'none', width: '80%', margin: '16px auto' }} />
          <MenuList
            theme="dark"
            mode="inline"
            defaultSelectedKeys={['1']}
          />
        </Sider>
      )
    }
    {
      isMobile && (
        <Layout>
          <Header style={{ position: 'fixed', width: '100%' }}>
            <Icon
              className="trigger"
              style={{ color: '#eee', fontSize: '1.8em' }}
              type={collapsed ? 'menu-unfold' : 'menu-fold'}
              onClick={() => setCollapsed((c) => !c)}
            />
          </Header>
          <WorkSpace />
        </Layout>
      )
    }
    {
      !isMobile && (
        <Layout>
          <Header style={{ position: 'fixed', width: '100%' }}>
            <Logo />
            <MenuList
              theme="dark"
              mode="horizontal"
              defaultSelectedKeys={['2']}
              style={{ lineHeight: '64px' }}
            />
          </Header>
          <WorkSpace />
        </Layout>
      )
    }
  </Layout>
)

const getRoutes = () => (
  <HashRouter>
    <Switch>
      <Route path="/login" component={stories['Login default']} />
      <Route path="/" component={enhance(App)} />
    </Switch>
  </HashRouter>
)


export default getRoutes



// WEBPACK FOOTER //
// ./src/routes.js